import { AxiosInstance } from 'axios'

import { EmployeePerson } from '@modules/employees/types/EmployeesPersons/employeesPersons'
import { CreateEmployeesWorkingDaysRequest } from '@modules/employees/types/EmployeesWorkingDays/requests'

export class EmployeesWorkingDaysService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(data: CreateEmployeesWorkingDaysRequest): Promise<EmployeePerson> {
    const { employeeId, ...body } = data

    const response = await this.instance.post(`/companies/employees/${employeeId}/working-days`, body)

    return response.data
  }
}

export const employeesWorkingDaysService = (instance: AxiosInstance) => new EmployeesWorkingDaysService(instance)
